<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200&display=swap");

.main {
  padding: 5px 10px;
  display: none;
}

.active {
  display: block !important;
}
.top-div {
  display: flex;
  flex-direction: column;
}

.steps {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0px 10px;
}

.steps .step .circle {
  height: 40px;
  width: 40px;
  background-color: #ccc;
  border-radius: 50%;
}
.steps .step .line {
  width: 22%;
}
.top-div img {
  width: 60px;
  margin-bottom: 10px;
}
.top-div p {
  color: #585e61;
  font-size: 14px;
  font-weight: 700;
}
.input-text {
  margin-bottom: 20px;
  margin-top: 10px;
}
input {
  height: 35px;
  width: 100%;
  font-size: 15px;
  font-weight: bold;
  background-color: rgba(0, 0, 0, 0.02);
}
textarea {
  background-color: rgba(0, 0, 0, 0.02);
}
.slct {
  background-color: initial;
}
select {
  height: 35px;
  width: 100%;
  font-size: 15px;
}
.input-text select option:nth-child(1) {
  display: none !important;
}
.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.final_button {
  margin-top: 130px;
}
.buttons button {
  height: 35px;
  outline: 0;
  border: 0;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
.warning {
  border-bottom: 1px solid red !important;
}

.check_box {
  text-align: center;
}
.check_box p {
  font-size: 13px;
  font-weight: 700;
}

.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: #7ac142;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: 10% auto;
  box-shadow: inset 0px 0px 0px #7ac142;
  animation: fill 0.4s ease-in-out 0.4s forwards,
    scale 0.3s ease-in-out 0.9s both;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%,
  100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #7ac142;
  }
}

.steps {
  width: 100%;
  counter-reset: css-counter 0;
  padding: 4px;
}

.steps li {
  list-style: none;
  width: 25%;
  float: left;
  position: relative;
  text-align: center;
  counter-increment: css-counter 1;
}

.steps li:before {
  content: counter(css-counter);

  height: 30px;
  width: 30px;
  background-color: #ccc;
  border-radius: 50%;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  color: #fff;
  line-height: 30px;
}

.steps li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: blue;
  top: 15px;
  z-index: -1;
}

li:first-child::after {
  display: none;
}

li.li-active::before {
  background-color: #007bff;
}
</style>
<template>
  <div class="container shadow-md mt-4">
    <div class="d-flex">
      <div class="card col-lg-7 col-lg-7 pt-4">
        <!-- style="background-color: whitesmoke"> -->
        <form action="">
          <div class="form">
            <div class="">
              <div class="signup-form s_form">
                <ul class="steps">
                  <li
                    v-for="i in nb + 1"
                    :key="i"
                    :class="forumnumber >= i - 1 ? 'li-active' : ''"
                  ></li>
                </ul>

                <div
                  class="main"
                  v-for="i in nb + 1"
                  :key="i"
                  :class="forumnumber >= i - 1 ? 'active' : ''"
                >
                  <div :style="i < nb + 1 ? 'display: block' : 'display: none'">
                    <div class="top-div">
                      <h3>{{ i }} Title page</h3>
                      <div class="row">
                        <div class="input-text col-lg-6">
                          <div class="input-group">
                            <input
                            type="text"
                            name="name"
                            placeholder="First name"
                            id="user_name"
                            require
                            class="form-control"
                          />
                          <div class="input-group-prepend">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle text-secondary"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                          </div>
                        </div>
                        <div class="input-text col-lg-6">
                          <div class="input-group">
                            <input
                            type="text"
                            placeholder="Last name"
                            require
                            class="form-control"
                          />
                          <div class="input-group-prepend">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle text-secondary"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                          </div>
                        </div>
                        <div class="input-text col-lg-6">
                          <div class="input-group">
                            <input
                            type="text"
                            placeholder="Village/Town/City"
                            require
                            class="form-control"
                          />
                          <div class="input-group-prepend">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle text-secondary"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                          </div>
                        </div>
                        <div class="input-text col-lg-6">
                          <div class="input-group">
                            <input
                            type="text"
                            placeholder="Country"
                            require
                            class="form-control"
                          />
                          <div class="input-group-prepend">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle text-secondary"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                          </div>
                        </div>
                        <div class="input-text col-lg-12">
                          <div class="input-group">
                            <input
                            type="email"
                            placeholder="email"
                            require
                            class="form-control"
                          />
                          <div class="input-group-prepend">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle text-secondary"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                          </div>
                        </div>
                        <div class="input-text col-lg-12">
                          <div class="input-group">
                          <textarea
                            name="description"
                            require
                            placeholder="Description"
                            class="font-weight-bold form-control"
                            aria-label="With textarea"
                          ></textarea>
                          <div class="input-group-prepend">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle text-secondary"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                        </div>
                        </div>
                        <div class="input-text col-lg-12">
                          <div class="input-group mb-3 slct">
                            <select
                              class="custom-select"
                              id="inputGroupSelect02"
                              required
                            >
                              <option selected disabled value="">Choose...</option>
                              <option value="Valeur1">Valeur 1</option>
                              <option value="Valeur2">Valeur 2</option>
                              <option value="Valeur3">Valeur 3</option>
                              <option value="Valeur4">Valeur 4</option>
                            </select>
                            <div class="input-group-append">
                              <button
                                type="button"
                                class="btn btn-outline-info border-0"
                                data-toggle="tooltip"
                                data-placement="right"
                                title="Tooltip on right"
                              >
                                <i
                                  class="fas fa-info-circle text-secondary"
                                  style="font-size: 20px"
                                ></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="buttons d-flex justify-content-end">
                      <button
                        type="button"
                        class="previous_button bg-outline-secondary"
                        :style="i > 1 ? 'display: block' : 'display: none'"
                      >
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        Previous
                      </button>
                      <button
                        type="button"
                        class="next_button bg-primary text-light"
                        :style="i == nb ? 'display: none' : 'display: block'"
                      >
                        Next
                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                      </button>
                      <button
                        type="button"
                        class="next_button btn bg-primary text-light"
                        :style="i == nb ? 'display: block' : 'display: none'"
                      >
                        Valider
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                  <div
                    class="buttons"
                    :style="i == nb + 1 ? 'display: block' : 'display: none'"
                  >
                    <div class="top-div">
                      <h2>Finish</h2>
                      <p>Log in to continue</p>
                    </div>
                    <svg
                      class="checkmark"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 52 52"
                    >
                      <circle
                        class="checkmark__circle"
                        cx="26"
                        cy="26"
                        r="25"
                        fill="none"
                      />
                      <path
                        class="checkmark__check"
                        fill="none"
                        d="M14.1 27.2l7.1 7.2 16.7-16.8"
                      />
                    </svg>
                    <div class="check_box">
                      <p>
                        Congratulations Mr./Mrs
                        <span id="shown_name"></span> you have successfully
                        registered.
                      </p>
                    </div>
                    <button
                      type="submit"
                      class="next_button bg-primary text-light"
                    >
                      Revenir
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-lg-5 col-lg-5 d-none d-md-block card">
        <img
          class=""
          :src="image"
          style="width: 100%; height: 100%; border-radius: 5px"
        />
      </div>
    </div>
  </div>
</template>
<script>
import sign from "../../../../../assets/img/authentication.png";
export default {
  data() {
    return {
      image: sign,
      nxt_btn: [],
      prev_btn: [],
      main_form: [],
      progressbar: [],
      steps: [],
      forumnumber: 0,
      validate_inputs: [],
      s_form: [],
      nb: 3,
    };
  },
  mounted() {
    this.nxt_btn = document.querySelectorAll(".next_button");
    this.prev_btn = document.querySelectorAll(".previous_button");
    this.main_form = document.querySelectorAll(".main");
    this.progressbar = document.querySelectorAll(".steps li");
    this.steps = document.querySelector(".steps");
    this.validate_inputs = [...document.querySelectorAll(".main.active input"), ...document.querySelectorAll(".main.active textarea")]
    this.s_form = document.querySelectorAll(".s_form");

    this.nxt_btn.forEach((butn) => {
      butn.addEventListener("click", this.onNext);
    }),
      this.prev_btn.forEach((prev_button) => {
        prev_button.addEventListener("click", this.onBack);
      });
    document.addEventListener("click", this.valeurs);
  },
  methods: {
    onNext() {
      if (!this.validateform()) {
        return false;
      }
      this.forumnumber++;
      this.progress("color");
      this.update_form();
    },
    onBack() {
      this.forumnumber--;
      this.progress("nocolor");
      this.update_form();
    },

    progress(state) {
      if (state == "color") {
        this.progressbar[this.forumnumber].classList.add("li-active");
      } else {
        this.progressbar[this.forumnumber + 1].classList.remove("li-active");
      }
    },
    update_form() {
      this.main_form.forEach(function (main) {
        main.classList.remove("active");
      });
      this.main_form[this.forumnumber].classList.add("active");
      this.validate_inputs = document.querySelectorAll(".main.active input");
    },

    validateform() {
      let validate = true;
      console.log(this.validate_inputs);
      this.validate_inputs.forEach(function (input_valid) {
        input_valid.classList.remove("warning");
        if (input_valid.hasAttribute("require")) {
          if (input_valid.value.length == 0) {
            validate = false;
            input_valid.classList.add("warning");
          }
        }
      });
      return validate;
    },
  },
};
</script>
